// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import ServicesSliderController from "./services_slider_controller"
application.register("services-slider", ServicesSliderController)

import TestimonialsController from "./testimonials_controller"
application.register("testimonials", TestimonialsController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import AnimationsController from "./animations_controller"
application.register("animations", AnimationsController)
